import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-data2",
  "use": "icon-data2-usage",
  "viewBox": "0 0 256 256",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\" id=\"icon-data2\">\r\n  <path d=\"M195,222 L195,240 L62,240 L62,222 L195,222 Z M240,16 L240,196 L16,196 L16,16 L240,16 Z M219,36 L37,36 L37,180 L219,180 L219,36 Z M88,101 L88,144 L72,144 L72,101 L88,101 Z M137,72 L137,144 L120,144 L120,72 L137,72 L137,72 Z M184,95 L184,144 L168,144 L168,95 L184,95 L184,95 Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol